module.exports = __webpack_public_path__ + "static/media/game.80b814e5.svg";